"use strict";
import { createMemo } from "solid-js";
import makeDocumentProjection from "./makeDocumentProjection.js";
import { access } from "@solid-primitives/utils";
export default function createDocumentProjection(handle) {
  const projection = createMemo(
    () => access(handle) && makeDocumentProjection(access(handle))
  );
  return projection;
}
//# sourceMappingURL=createDocumentProjection.js.map
